import type { ReactNode } from 'react';
import { Alert, Button, Skeleton, Stack } from '@mui/material';
import type { UseQueryResult } from '@tanstack/react-query';
import { errorMessage } from '@/api/errorMessage';

/**
 * Standard loading / error rendering for a query, so every screen handles the
 * three states the same way.
 */
export function QueryState<T>({
  query,
  children,
  skeleton,
}: {
  query: UseQueryResult<T>;
  children: (data: T) => ReactNode;
  skeleton?: ReactNode;
}) {
  if (query.isPending) {
    return (
      skeleton ?? (
        <Stack spacing={1.5} aria-busy="true" aria-label="Carregando">
          <Skeleton variant="rounded" height={56} />
          <Skeleton variant="rounded" height={56} />
          <Skeleton variant="rounded" height={56} />
        </Stack>
      )
    );
  }
  if (query.isError) {
    return (
      <Alert
        severity="error"
        action={
          <Button color="inherit" onClick={() => void query.refetch()}>
            Tentar de novo
          </Button>
        }
      >
        {errorMessage(query.error)}
      </Alert>
    );
  }
  return children(query.data);
}
